<section class="page">
  <header class="page-header">
    <h2>Modifier une nomenclature et ses composants</h2>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  <form class="panel">
    <fieldset>
      <legend>Sélection de la nomenclature</legend>

      @if (loadingNomenclatures) {
        <p>Chargement des nomenclatures...</p>
      } @else {
        <label for="select-nomenclature">Nomenclature</label>
        <select
          id="select-nomenclature"
          [(ngModel)]="selectedNomenclatureId"
          name="selectedNomenclatureId"
          (ngModelChange)="onNomenclatureSelect()"
        >
          <option value="">-- sélectionner --</option>
          @for (nomenclature of nomenclatures; track nomenclature.id) {
            <option [value]="nomenclature.id">N° {{ nomenclature.numero_nomenclature }} - {{ nomenclature.nom }} ({{ nomenclature.date_creation }})</option>
          }
        </select>
      }
    </fieldset>

    @if (selectedNomenclatureId) {
      <fieldset>
        <legend>Informations de la nomenclature</legend>

        <label for="numero">Numéro</label>
        <input id="numero" type="number" [(ngModel)]="numeroNomenclature" name="numeroNomenclature" min="0" max="999999999" />

        <label for="nom">Nom</label>
        <input id="nom" type="text" [(ngModel)]="nomNomenclature" name="nomNomenclature" maxlength="255" />

        <label for="date">Date de création</label>
        <input id="date" type="date" [(ngModel)]="dateCreation" name="dateCreation" />

        <button type="button" [disabled]="loading" (click)="updateNomenclatureInfo()">
          {{ loading ? 'Enregistrement...' : 'Enregistrer les informations' }}
        </button>
      </fieldset>

      <fieldset>
        <legend>Ajouter un composant</legend>

        @if (loadingComposants) {
          <p>Chargement des composants...</p>
        } @else if (composants.length === 0) {
          <p>Aucun composant disponible. Créez d'abord un composant dans le menu "Composants".</p>
        } @else {
          <label for="select-composant">Composant</label>
          <select id="select-composant" [(ngModel)]="selectedComposantId" name="selectedComposantId">
            <option value="">-- sélectionner --</option>
            @for (composant of composants; track composant.id) {
              <option [value]="composant.id">{{ composant.nom }}</option>
            }
          </select>

          <label for="quantite">Quantité</label>
          <input id="quantite" type="number" [(ngModel)]="selectedQuantite" name="selectedQuantite" min="1" required />

          <button
            type="button"
            [disabled]="addingComposant || !selectedComposantId || !selectedQuantite"
            (click)="addComposantToNomenclature()"
          >
            {{ addingComposant ? 'Ajout...' : 'Ajouter le composant' }}
          </button>
        }
      </fieldset>

      <fieldset>
        <legend>Composants de la nomenclature</legend>

        @if (nomenclatureComposants.length === 0) {
          <p>Aucun composant dans cette nomenclature.</p>
        } @else {
          <div class="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Composant</th>
                  <th>Quantité</th>
                  <th>Prix unitaire</th>
                  <th>Prix total</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (nc of nomenclatureComposants; track nc.composant_id) {
                  <tr>
                    <td>{{ getComposantName(nc.composant_id) }}</td>
                    <td>
                      @if (editingComposantId === nc.composant_id) {
                        <input type="number" [(ngModel)]="editingQuantite" name="editingQuantite" min="1" />
                      } @else {
                        {{ nc.quantite }}
                      }
                    </td>
                    <td>{{ getPrixUnitaire(nc.composant_id) !== null ? (getPrixUnitaire(nc.composant_id) | currency:'EUR':'symbol':'1.2-2':'fr-FR') : '-' }}</td>
                    <td>{{ getPrixTotal(nc.composant_id, nc.quantite) !== null ? (getPrixTotal(nc.composant_id, nc.quantite) | currency:'EUR':'symbol':'1.2-2':'fr-FR') : '-' }}</td>
                    <td class="actions-cell">
                      @if (editingComposantId === nc.composant_id) {
                        <button
                          type="button"
                          [disabled]="updatingComposantId === nc.composant_id"
                          (click)="updateComposantQuantite(nc.composant_id)"
                        >
                          {{ updatingComposantId === nc.composant_id ? 'Enregistrement...' : 'Enregistrer' }}
                        </button>
                        <button
                          type="button"
                          class="secondary"
                          [disabled]="updatingComposantId === nc.composant_id"
                          (click)="cancelEditingComposant()"
                        >
                          Annuler
                        </button>
                      } @else {
                        <button
                          type="button"
                          class="secondary"
                          (click)="startEditingComposant(nc)"
                        >
                          Modifier
                        </button>
                        <button
                          type="button"
                          class="secondary"
                          (click)="editComposant(nc.composant_id)"
                        >
                          Éditer le composant
                        </button>
                        <button
                          type="button"
                          class="danger"
                          [disabled]="removingComposantId === nc.composant_id"
                          (click)="removeComposantFromNomenclature(nc.composant_id)"
                        >
                          {{ removingComposantId === nc.composant_id ? 'Suppression...' : 'Supprimer' }}
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </fieldset>
    }
  </form>
</section>
